import { z } from "zod";

/** Texto opcional: ausente, null, "" ou só espaços viram null. Um PUT sem o campo limpa o valor (DAD19). */
export const text = (max: number) =>
  z
    .string()
    .trim()
    .max(max)
    .nullish()
    .transform((v) => (v ? v : null));
/** Mesma normalização; o resultado ainda passa pelo schema do formato (`.pipe`). */
export const blank = z
  .string()
  .trim()
  .nullish()
  .transform((v) => (v ? v : null));
export const num = <T extends z.ZodNumber>(s: T) => s.nullish().transform((v) => v ?? null);
